import React, { useEffect, useState } from "react";
import ModalAdditionalSeats from "../../Modal/ModalAdditionalSeats.jsx";
import { MATERIAL_UI_PROPS } from "../../../lib/data";
import { Button } from "@material-ui/core";
import moment from "moment";
import axios from "axios";

export const additionalSeats = (field) => {
    const [isOpen, setIsOpen] = useState(false);

    const url = window.location.pathname;
    const rateId = url.split("/")[5];

    const toggleModal = (e) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    };

    const todayDate = moment().format("YYYY-MM-DD");
    const tomorrowDate = moment().add(1, "day").format("YYYY-MM-DD");

    const defaultObject = {
        id: 0,
        start_value: todayDate,
        end_value: tomorrowDate,
        price_value: 0,
    };

    const namesIdAdds = [
        "children",
        "add_seat",
        "add_seat_baby",
        "add_seat_children",
        "without_seat_baby",
    ];

    const names = [
        "РЕБЕНОК",
        "ДОП. МЕСТО",
        "ДОП.МЕСТО (МЛАДЕНЕЦ)",
        "ДОП.МЕСТО (РЕБЕНОК)",
        "Б/МЕСТА (МЛАДЕНЕЦ)",
    ];

    const defaultRules = [];

    namesIdAdds.forEach((name) => (defaultRules[name] = [defaultObject]));

    const [data, setData] = useState(defaultRules);
    const [count, setCount] = useState({ count: 0 });

    const add = (e) => {
        e.preventDefault();
        const buffData = data;

        let sign;
        const el = {};
        for (let [k, v] of Object.entries(e.target)) {
            if (k === "0") sign = v.value;
            if (k === "1") el.idx = v.value;
            if (k === "2") el.start_value = v.value;
            if (k === "3") el.end_value = v.value;
            if (k === "4") el.price_value = v.value;
        }

        document.getElementById(sign + "_price" + 0).value = 0;

        const els = document.getElementsByClassName(sign);

        for (let [k, v] of Object.entries(els[els?.length - 1])) {
            if (k === "1") el.id = sign + (Number(v.value) + 1);
        }

        buffData[sign].push(el);
        setData(buffData);
        setCount((prevState) => ({
            count: prevState.count + 1,
        }));
    };

    const removeItem = (prevData, id) => {
        const newData = { ...prevData };
        for (let [k, v] of Object.entries(prevData)) {
            newData[k] = v.filter((el) => el.id !== id);
        }
        return newData;
    };

    const del = (id) => {
        setData((prevData) => removeItem(prevData, id));
    };

    const save = () => {
        setIsOpen(!isOpen);

        const dataSend = Object.assign({}, data);

        axios
            .post("/manager/data/hotels/save_add/" + rateId, { dataSend })
            .catch((error) => alert(error));
    };

    return (
        <div>
            <Button
                color={MATERIAL_UI_PROPS.colors.primary}
                variant={MATERIAL_UI_PROPS.varinats.contained}
                onClick={toggleModal}
            >
                Редактировать
            </Button>
            {isOpen && (
                <ModalAdditionalSeats
                    onClose={toggleModal}
                    names={names}
                    save={save}
                    isOpen={isOpen}
                    data={data}
                    setData={setData}
                    add={add}
                    del={del}
                    namesIdAdds={namesIdAdds}
                    rateId={rateId}
                />
            )}
        </div>
    );
};
